<!--Galeria para visualizar archivo tipo imagen-->
<p-dialog
    [header]="'Archivo: ' + fileName"
    [modal]="true"
    (onHide)="closeViewerPdf()"
    [(visible)]="dialogPdfView"
    [style]="{ width: '80%', height: '80%' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true"
    (onShow)="initializePdfViewer()">
    <div style="width: 100%; height: 100%;">
        <shared-loader [hidden]="!_showLoader"></shared-loader>
        <ng-container *ngIf="pdfSrc">
            <ng2-pdfjs-viewer
                class="fill"
                viewerId="MyID2"
                #viewer
                [pdfSrc]="pdfSrc"
                [pagemode]="'none'"
                [fullScreen]="false"
                locale="es-Es"
                cursor="HAND"
                scroll="W"
                [spread]="'N'"
                [zoom]="zoom"
                [openFile]="false"
                [download]="true"
                [find]="false"
                [externalWindow]="false"
                [print]="false"
                [showSpinner]="false"
                [downloadFileName]="fileName"
                [externalWindowOptions]="'toolbar=no,location=no'"
                [errorAppend]="false"
                [errorOverride]="true"
                errorMessage="Archivo no disponible en estos momentos"
                (error)="pdfError($event)"
                (onDocumentLoad)="pdfLoaded($event)"
                style="width: 100%; height: 100%;">
            </ng2-pdfjs-viewer>
        </ng-container>
    </div>
</p-dialog>
